import React from 'react';

import InputWrapper from './InputWrapper';

const TextAreaClass = (props) => {
  return <textarea {...props} />;
};

const TextArea = (props) => {
  return <InputWrapper {...props} component={TextAreaClass} />;
};

export default TextArea;
